<template>
  <!-- 在线咨询其他回答list -->
  <div class="onlitdetlist">
    <div class="onlitwt">还有<span>5</span>位律师回答了</div>
    <div class="onlithd">
      <div class="hditem flex_start" v-for="item in 5" :key="item">
        <div class="hdlawcov">
          <img src="../../../assets/case/aaaa2_sample.png" alt="" />
        </div>
        <div class="lawjs">
          <div class="lawname flex_start">
            杨洋律师 <img src="../../../assets/case/uservipicon.png" />
          </div>
          <div class="lawsertiem">
            <span> 解答时间：2021-04-22 08:14:58</span
            ><span>服务地区：辽宁-葫芦岛</span>
          </div>
          <div class="lawjdnr">
            你好，要看你们如何约定才能确定，如果不按约定办理的话可以通过法院诉讼途径解决！
            微或电询。
          </div>
          <div class="lawbz">
            若有未尽事宜可以或致电
            <span>145-9888-1456</span>
            <span class="zxfztxt">（咨询请说明来自律观网）</span>
          </div>
          <div class="twbutn">咨询我</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.onlitdetlist {
  width: 100%;
  padding: 38px 40px 12px;
  .onlitwt {
    span {
      color: #0465ea;
    }
  }
  .onlithd {
    .hditem {
      align-items: flex-start;
      padding: 30px 0;
      .hdlawcov {
        margin-right: 20px;
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
      }
      .lawjs {
        position: relative;
        .lawname {
          font-size: 16px;
          color: #333;
          margin-top: 10px;
          img {
            margin-left: 8px;
            width: 16px;
            height: 16px;
          }
        }
        .lawsertiem {
          margin-top: 10px;
          font-size: 12px;
          color: #c8c8c8;
          span {
            margin-right: 20px;
          }
        }
        .lawjdnr {
          margin-top: 20px;
          font-size: 18px;
          color: #333333;
          line-height: 26px;
        }
        .lawbz {
          margin-top: 10px;
          font-size: 14px;
          color: #666666;
          .zxfztxt {
            color: #c8c8c8;
          }
        }
        .twbutn {
          cursor: pointer;
          position: absolute;
          top: 30px;
          right: 0;
          width: 112px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background: #0465ea;
          border-radius: 15px;
          font-size: 14px;
          color: #ffffff;
          &:hover {
            background-color: #3689fb;
          }
        }
        
      }
      &:hover {
         .lawjs .lawname {
            color: #0f8ae7;
          }
        }
    }
  }
}
</style>